import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { HeatmapPage } from '../../pages/HeatmapPage';
import { GeneralStimmenPage } from '../../pages/GeneralStimmenPage';
import { ActionHubPage } from '../../pages/ActionHubPage';
import { StrategicAdvisorPage } from '../../pages/StrategicAdvisorPage';
import { PersonalReputationPage } from '../../pages/PersonalReputationPage';
import { InvestitionReputationPage } from '../../pages/InvestitionReputationPage';
import { ServicesReputationPage } from '../../pages/ServicesReputationPage';
import { CompetitorRadarPage } from '../../pages/CompetitorRadarPage';
import { KonzernStimmungPage } from '../../pages/KonzernStimmungPage';
import { MarktStimmungPage } from '../../pages/MarktStimmungPage';
function PlaceholderPage({
  title,
  description
}: {
  title: string;
  description: string;
}) {
  return <div className="flex-1 flex items-center justify-center p-8" data-id="element-1">
      <div className="text-center max-w-md" data-id="element-2">
        <div className="w-16 h-16 rounded-2xl bg-aldi-blue/10 flex items-center justify-center mx-auto mb-4" data-id="element-3">
          <svg className="w-8 h-8 text-aldi-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" data-id="element-5" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-6">{title}</h2>
        <p className="text-gray-500 text-sm" data-id="element-7">{description}</p>
        <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 bg-aldi-accent/20 text-aldi-blue text-sm font-medium rounded-lg" data-id="element-8">
          <span className="w-2 h-2 rounded-full bg-aldi-accent animate-pulse" data-id="element-9"></span>
          In Entwicklung
        </div>
      </div>
    </div>;
}
export function DashboardLayout() {
  const [activeTab, setActiveTab] = useState('heatmap');
  const [selectedMarket, setSelectedMarket] = useState<string | null>(null);
  const renderPage = () => {
    switch (activeTab) {
      case 'heatmap':
        return <HeatmapPage data-id="element-10" />;
      case 'general-stimmen':
        return <GeneralStimmenPage data-id="element-11" />;
      case 'konzern-stimmung':
        return <KonzernStimmungPage data-id="element-12" />;
      case 'churn-warner':
        return <PlaceholderPage title="Churn-Warner" description="Frühwarnsystem für Kundenabwanderung basierend auf Bewertungstrends und Sentiment-Analysen." data-id="element-13" />;
      case 'brand-sentiment':
        return <PlaceholderPage title="Brand Sentiment Radar" description="Analyse der Markenwahrnehmung über alle Kanäle hinweg mit Social Media Integration." data-id="element-14" />;
      case 'markt-stimmung':
        return <MarktStimmungPage selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} data-id="element-15" />;
      case 'bewertungs-hub':
        return <ActionHubPage selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} data-id="element-16" />;
      case 'umsatz-reputation':
        return <StrategicAdvisorPage data-id="element-17" />;
      case 'personal-reputation':
        return <PersonalReputationPage data-id="element-18" />;
      case 'investition-reputation':
        return <InvestitionReputationPage data-id="element-19" />;
      case 'services-reputation':
        return <ServicesReputationPage data-id="element-20" />;
      case 'wettbewerbsradar':
        return <CompetitorRadarPage data-id="element-21" />;
      default:
        return <HeatmapPage data-id="element-22" />;
    }
  };
  return <div className="min-h-screen bg-aldi-light flex" data-id="element-23">
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} data-id="element-24" />
      <div className="flex-1 flex flex-col ml-[72px] lg:ml-[280px] transition-all duration-300" data-id="element-25">
        <main className="flex-1 relative overflow-hidden" data-id="element-26">{renderPage()}</main>
      </div>
    </div>;
}